import { Routes } from '@angular/router';
import { ReportsContainerComponent } from './containers/reports-container/reports-container.component';

export const reportsRoutes: Routes = [
    {
        path:       '',
        component:  ReportsContainerComponent
    },
];
